// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetNewbuildingsForSerpRequest,
  TGetNewbuildingsForSerpModel,
  IMappers,
  TGetNewbuildingsForSerpResponse,
  IGetNewbuildingsForSerpResponse,
  IGetNewbuildingsForSerpResponseError,
} from './types';

export const defaultConfig: TGetNewbuildingsForSerpModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-search',
  pathApi: '/v1/get-newbuildings-for-serp/',
  requestType: 'json',
  responseType: 'json',
} as TGetNewbuildingsForSerpModel;

export function createGetNewbuildingsForSerpModel(
  parameters: IGetNewbuildingsForSerpRequest,
): TGetNewbuildingsForSerpModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingsForSerpOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetNewbuildingsForSerpRequest;
}

export async function fetchGetNewbuildingsForSerp<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsForSerpOptions<TResponse200, TResponse400>): Promise<
  TGetNewbuildingsForSerpResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetNewbuildingsForSerpModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsForSerpResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingsForSerpResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetNewbuildingsForSerpResponse;
}
